import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component CollapseAllIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <CollapseAllIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <CollapseAllIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const CollapseAllIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="CollapseAllIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="nonzero"
        d="m12 15 4.72 4.461a.867.867 0 0 1 0 1.275.993.993 0 0 1-1.348 0L12 17.549l-3.372 3.187a.993.993 0 0 1-1.349 0 .867.867 0 0 1 0-1.275zm4.72-11.736a.867.867 0 0 1 0 1.275L12 9 7.28 4.539a.867.867 0 0 1 0-1.275.993.993 0 0 1 1.348 0L12 6.451l3.372-3.187a.993.993 0 0 1 1.349 0M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
      />
    </svg>
  )
);
CollapseAllIcon.displayName = "CollapseAllIcon";
export default CollapseAllIcon;
